import { useLayoutEffect } from "react";

class Background extends EventTarget {
  public val: string = "";
}

export const background = new Background();

export const useBackground = (value: string) => {
  useLayoutEffect(() => {
    background.val = value;
    background.dispatchEvent(
      new CustomEvent<{ value: string }>("update", { detail: { value } }),
    );
    return () => {
      background.val = "";
      background.dispatchEvent(
        new CustomEvent<{ value: string }>("update", { detail: { value: "" } }),
      );
    };
  }, [value]);
};
